import React from "react";
import { useTranslation } from "react-i18next";
import Highlighter from "react-highlight-words";
import { Grid3x3, MoreVertical } from "lucide-react";
import SubMenu from "./SubMenu";

const TerminalItem = ({
  terminal,
  branch,
  outlet,
  branchId,
  searchTerm,
  subMenuID,
  setSubMenuID,
  expandedBranches,
  actions,
}) => {
  const { t: translate } = useTranslation();

  return (
    <div
      key={terminal.id}
      className="flex items-center justify-start pb-1"
      data-testid={`terminal-${terminal.id}`}
    >
      <div className="flex flex-col items-end gap-3 dark:bg-gray-900 dark:text-white bg-gray-200 rounded-lg px-4 py-2">
        <button
          data-testid={`terminal-action-${terminal.id}`}
          className="hover:bg-gray-100 transition-colors duration-300 relative"
          onClick={() => setSubMenuID(terminal.id)}
        >
          <MoreVertical size={20} />
          {subMenuID === terminal.id &&
            subMenuID !== null &&
            expandedBranches[branchId] && (
              <SubMenu
                id={branch}
                type="terminal"
                actions={actions}
                parent={outlet}
                isTerminal={true}
                sentTerminalId={terminal.id}
                onClose={() => setSubMenuID(null)}
              />
            )}
        </button>
        <div className="flex items-center gap-2">
          <Grid3x3 size={20} />

          <h4 className="font-medium">
            <Highlighter
              highlightClassName="text-red-500 bg-transparent"
              searchWords={[searchTerm]}
              autoEscape={true}
              textToHighlight={terminal.name}
            />
          </h4>
        </div>
      </div>
    </div>
  );
};

export default TerminalItem;
